/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import WineDialog from './WineDialog';

const styles = () => ({
    wineContent: {
        width: '96%',
        margin: '5px 0px 0px 0px',
    },
    link: {
        fontSize: '16px',
        fontFamily: 'lato regular',
        textDecoration: 'underline',
    },
    disclaimerContent: {
        fontSize: '16px',
        fontFamily: 'lato regular',
    },
    promotion: {
        margin: '10px 0px 0px 0px',
        display: 'block',
    },
});

class WineDisclaimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDialog: false,
        };
    }

    openDialog = () => {
        this.setState({ openDialog: true });
    }

    closeDialog = () => {
        this.setState({ openDialog: false });
    }

    render() {
        const { classes, data } = this.props;
        const { openDialog } = this.state;
        return (
            <div className={classes.wineContent}>
                <div
                    onClick={this.openDialog}
                    onKeyDown={() => { }}
                    role="button"
                    tabIndex={-1}
                    className={classes.link}
                >
                    Click Here
                </div>
                {openDialog
                && (
                    <WineDialog
                        oncloseDialog={this.closeDialog}
                        data={data}
                    />
                )}
                <div>
                    for further details and restrictions relating to the purchase of wine, and a list of states to which Harry &amp; David wine can be shipped.
                    You must be 21 years of age or older to order, purchase or receive delivery of wine.
                    A person who is 21 years of age or older must be home to sign for the delivery. Offer void where prohibited by law.
                </div>
                <div className={classes.promotion}>
                    <strong>Promotions, Celebrations Passport®, coupons and special offers do not apply to products containing wine.</strong>
                    <p>Harry &amp; David wine is sold and shipped by Harry and David, LLC, Medford, Oregon.</p>
                </div>
                <div className={classes.promotion}>
                    <strong>Warning:</strong>
                    <p>Drinking distilled spirits, beer, coolers, wine, and other alcoholic beverages may increase cancer risk, and during pregnancy, can cause birth defects. For more information go to.</p>
                </div>
            </div>
        );
    }
}
WineDisclaimer.propTypes = {
    classes: object.isRequired,
    data: object.isRequired,
};
export default withStyles(styles)(WineDisclaimer);
